import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserEditFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.0429 10.0429C19.1238 8.96201 20.8762 8.962 21.9571 10.0429C23.0381 11.1237 23.0381 12.8763 21.9571 13.9572C19.7973 16.117 17.6338 18.2732 15.4776 20.4366C15.3925 20.5221 15.2852 20.6297 15.1597 20.7219C15.0506 20.802 14.9336 20.8708 14.8106 20.9272C14.6691 20.9922 14.5229 21.0337 14.4069 21.0667C13.3623 21.3632 12.3188 21.6632 11.2747 21.9615C10.9255 22.0613 10.5497 21.9639 10.2929 21.7071C10.0361 21.4503 9.93871 21.0745 10.0385 20.7253C10.3368 19.6812 10.6368 18.6377 10.9333 17.5931C10.9663 17.4771 11.0078 17.3309 11.0728 17.1894C11.1292 17.0664 11.198 16.9494 11.2781 16.8403C11.3703 16.7148 11.4779 16.6075 11.5634 16.5224C13.7269 14.3662 15.8831 12.2027 18.0429 10.0429Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.60988 14.5101C6.7551 14.522 6.96309 14.5524 7.18104 14.6635C7.46328 14.8073 7.69275 15.0368 7.83656 15.319C7.94761 15.537 7.97805 15.745 7.98992 15.8902C8.00016 16.0155 8.0001 16.1578 8.00006 16.2769C7.99957 17.5923 7.99957 18.9077 8.00006 20.2231C8.0001 20.3423 8.00016 20.4845 7.98992 20.6098C7.97805 20.7551 7.94761 20.963 7.83656 21.181C7.69275 21.4632 7.46328 21.6927 7.18104 21.8365C6.96309 21.9476 6.7551 21.978 6.60988 21.9899C6.48456 22.0001 6.34231 22.0001 6.22319 22C3.3458 21.999 5.46791 21.9847 2.59057 22.0001C2.5192 22.0005 2.37575 22.0012 2.23958 21.9772C1.61856 21.8677 1.13234 21.3815 1.02284 20.7605C0.998829 20.6243 0.999593 20.4809 0.999973 20.4095C1.00312 19.8186 0.972938 19.2163 1.07601 18.6318C1.44102 16.5617 3.06175 14.941 5.13181 14.576C5.77865 14.4619 6.34183 14.4882 6.60988 14.5101Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.50005 7.5C4.50005 4.46243 6.96248 2 10.0001 2C13.0376 2 15.5001 4.46243 15.5001 7.5C15.5001 10.5376 13.0376 13 10.0001 13C6.96248 13 4.50005 10.5376 4.50005 7.5Z",
			fill: "currentColor"
		})
	]
});
export default SvgUserEditFilled;
